import HTTPClient from './httpClient.js';

var annotations;
(function (annotations) {
    class Service extends HTTPClient {
        localPath = '/v2/annotations';
        list = (req) => this.client.get(this.localPath, {}, req);
        get = (id) => this.client.get(this.localPath + '/' + id);
        create = (req) => this.client.post(this.localPath, { body: JSON.stringify(req) });
        update = (id, req) => this.client.put(this.localPath + '/' + id, { body: JSON.stringify(req) });
        delete = (id) => this.client.delete(this.localPath + '/' + id);
    }
    annotations.Service = Service;
})(annotations || (annotations = {}));

export { annotations };
//# sourceMappingURL=annotations.js.map
